import React from 'react'
import classNames from 'classnames'
import type { TOutsideLabelProps } from './types'
import './styles.scss'

export const OutsideLabel: React.FC<TOutsideLabelProps> = ({ text, children, className }) => {
  return (
    <label className={classNames(className, 'outsideLabel')}>
      <span className="outsideLabel__text">{text}</span>
      {children}
    </label>
  )
}
